import React from 'react';

import { PageReactDataTable } from '@metarouter-private/mr-mui';

import usePipelineTagsTableProps from './usePipelineTagsTableProps';

export default function PipelineTagsTable() {
  const tableProps = usePipelineTagsTableProps();

  return <PageReactDataTable {...tableProps} />;
}
